<template>
  <detail-layout-full-width>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
        >
        <div class="lg:max-w-detail lg:mr-auto">
          <div class="flex items-center"
            v-if="!modeTemplate"
          >
            <input
              class='k-checkbox !mr-2 checkbox-lg'
              type='checkbox'
              v-model="checkall"
              @click="changeAllCheckbox(!checkall)"
            />
            <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block">Marcar todos los campos</label>
          </div>

          <h2 class="dark:text-darkblue-200 font-bold mt-6 mb-4">{{$t('groups.data')}}</h2>
          <div class="mb-6">
              <div class="flex flex-col lg:flex-row lg:space-x-4">
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.verTodoGroups"
                  />
                  <label for="switch-ver-todo-groups" class="sr-only">
                    {{$t('configurations.ver_todo_groups')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('configurations.ver_todo_groups')}}
                  </label>
                  <el-switch 
                    id="switch-ver-todo-groups"
                    :aria-label="$t('configurations.ver_todo_groups')"
                    :disabled="!hasPermissionEditVisiblity"
                    class="switch-text break-normal" 
                    v-model="form.verTodoGroups" 
                    :active-text="$t('configurations.ver_todo_groups')"/>
                  <base-tooltip-icon size="sm" :content="tooltipverTodoGroups" class="ml-1"/>
                </div>
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.verTodoStatuses"
                  />
                  <label for="switch-ver-todo-statuses" class="sr-only">
                    {{$t('configurations.ver_todo_statuses')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('configurations.ver_todo_statuses')}}
                  </label>
                  <el-switch 
                    id="switch-ver-todo-statuses"
                    :aria-label="$t('configurations.ver_todo_statuses')"
                    :disabled="!hasPermissionEditVisiblity"
                    class="switch-text break-normal" 
                    v-model="form.verTodoStatuses" 
                    :active-text="$t('configurations.ver_todo_statuses')"/>
                  <base-tooltip-icon size="sm" :content="tooltipVerTodoStatuses" class="ml-1"/>
                </div>
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.verTodoCompanies"
                  />
                  <label for="switch-ver-todo-companies" class="sr-only">
                    {{$t('configurations.ver_todo_companies')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('configurations.ver_todo_companies')}}
                  </label>
                  <el-switch 
                    id="switch-ver-todo-companies"
                    :aria-label="$t('configurations.ver_todo_companies')"
                    :disabled="!hasPermissionEditVisiblity"
                    class="switch-text break-normal" 
                    v-model="form.verTodoCompanies" 
                    :active-text="$t('configurations.ver_todo_companies')"/>
                  <base-tooltip-icon size="sm" :content="tooltipVerTodoCompanies" class="ml-1"/>
                </div>
              </div>
            </div>

          <h2 class="dark:text-darkblue-200 font-bold mt-6 mb-4">{{$t('companies.group_alert')}}</h2>

          <base-collapsible-form 
            ref="baseCollapsibleAlerts" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('companies.group_alert')}}</h2>
            </template>
            <template slot="content">

              <div class="mt-2 mb-4">
                <div class="mandatory flex items-center mb-4">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.EnviarAvisos"
                  />
                  <label for="switch-enviar-avisos" class="sr-only">
                    {{$t('companies.active')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('companies.active')}}
                  </label>
                  <el-switch 
                    id="switch-enviar-avisos"
                    :aria-label="$t('companies.active')"
                    class="switch-text break-normal" 
                    v-model="form.EnviarAvisos" 
                    :active-text="$t('companies.active')"></el-switch>
                </div>
                <div class="mandatory flex items-center">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.EnviarAvisosUsuarios"
                  />
                  <label for="switch-enviar-avisos-usuarios" class="sr-only">
                    {{$t('configurations.send_alerts_users')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('configurations.send_alerts_users')}}
                  </label>
                  <el-switch 
                    id="switch-enviar-avisos-usuarios"
                    :aria-label="$t('configurations.send_alerts_users')"
                    class="switch-text break-normal" 
                    v-model="form.EnviarAvisosUsuarios" 
                    :active-text="$t('configurations.send_alerts_users')"></el-switch>
                </div>
              </div>

              <div class="">
                <div class="mandatory flex items-center">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.EmailAvisoNueva"
                  />
                  <div class="w-full">
                    <div class="flex items-center justify-between">
                      <label for="switch-email-aviso-nueva" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                        {{$t('companies.email_alerts')}}
                        <span class="sr-only">{{$t('app.options')}}: {{$t('configurations.add')}} / {{$t('configurations.sustitute')}}</span>
                      </label>
                      <el-switch 
                        v-if="!modeTemplate"
                        id="switch-email-aviso-nueva"
                        :aria-label="$t('companies.email_alerts')"
                        class="switch-text break-normal both-switch mt-2" 
                        v-model="valuesAdd.EmailAvisoNueva" 
                        :inactive-text="$t('configurations.add')"
                        :active-text="$t('configurations.sustitute')" 
                        inactive-color="var(--primary-800)"
                        />
                    </div>
                    <el-form-item prop="EmailAvisoNueva">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.EmailAvisoNueva"
                        maxlength='500'
                      />
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="">
                <div class="mandatory flex items-center">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.EmailAvisoDescargada"
                  />
                  <div class="w-full">
                    <div class="flex items-center justify-between">
                      <label for="switch-email-aviso-descargada" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                        {{$t('companies.email_downloads')}}
                        <span class="sr-only">{{$t('app.options')}}: {{$t('configurations.add')}} / {{$t('configurations.sustitute')}}</span>
                      </label>
                      <el-switch 
                        v-if="!modeTemplate"
                        id="switch-email-aviso-descargada"
                        :aria-label="$t('companies.email_downloads')"
                        class="switch-text break-normal both-switch mt-2" 
                        v-model="valuesAdd.EmailAvisoDescargada" 
                        :inactive-text="$t('configurations.add')"
                        :active-text="$t('configurations.sustitute')" 
                        inactive-color="var(--primary-800)"
                        />
                    </div>
                  <el-form-item prop="EmailAvisoDescargada">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.EmailAvisoDescargada"
                      maxlength='500'
                    />
                  </el-form-item>
                </div>
                </div>
              </div>

              <div class="">
                <div class="mandatory flex items-center">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.EmailAvisoTramitada"
                  />
                  <div class="w-full">
                    <div class="flex items-center justify-between">
                      <label for="switch-email-aviso-tramitada" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                        {{$t('companies.email_tramitada')}}
                        <span class="sr-only">{{$t('app.options')}}: {{$t('configurations.add')}} / {{$t('configurations.sustitute')}}</span>
                      </label>
                      <el-switch 
                        v-if="!modeTemplate"
                        id="switch-email-aviso-tramitada"
                        :aria-label="$t('companies.email_tramitada')"
                        class="switch-text break-normal both-switch mt-2" 
                        v-model="valuesAdd.EmailAvisoTramitada" 
                        :inactive-text="$t('configurations.add')"
                        :active-text="$t('configurations.sustitute')" 
                        inactive-color="var(--primary-800)"
                        />
                    </div>
                  <el-form-item prop="EmailAvisoTramitada">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.EmailAvisoTramitada"
                      maxlength='500'
                    />
                  </el-form-item>
                </div>
                </div>
              </div>
              
              <div class="lg:mb-0">
                <div class="flex -mx-2 flex-col lg:flex-row">
                  <div class="px-2 w-full lg:mb-0">
                  <div class="mandatory flex items-center">
                    <input
                      v-if="!modeTemplate"
                      class='k-checkbox !mr-2 checkbox-lg'
                      type='checkbox'
                      v-model="valuesCheckbox.DiasAviso"
                    />
                    <div class="w-full">
                    <div class="flex items-center mb-1">
                      <label class="text-sm font-semibold text-secondary-600 block">{{$t('companies.download_alert_days_form')}}</label>
                      <base-tooltip-icon size="sm" :content="$t('configurations.days_groups_tooltip')" class="ml-2"/>
                    </div>
                      <el-form-item prop="DiasAviso">
                        <el-input
                          clearable
                          v-model="form.DiasAviso"
                          maxlength='5'
                          :placeholder="$t('configurations.default_disabled')"
                        />
                      </el-form-item>
                    </div>
                  </div>
                </div>
                  <div class="px-2 w-full lg:mb-0 flex items-center">
                    <input
                      v-if="!modeTemplate"
                      class='k-checkbox !mr-2 checkbox-lg'
                      type='checkbox'
                      v-model="valuesCheckbox.DiasFinTramite"
                    />
                    <div class="w-full">
                    <div class="flex items-center mb-1">
                      <label class="text-sm font-semibold text-secondary-600 block">{{$t('companies.end_alert_days_label_form')}}</label>
                      <base-tooltip-icon size="sm" :content="$t('configurations.days_groups_tooltip')" class="ml-2"/>
                    </div>
                      <el-form-item prop="DiasFinTramite">
                        <el-input
                          clearable
                          v-model="form.DiasFinTramite"
                          maxlength='5'
                        />
                      </el-form-item>  
                    </div>
                  </div>
                </div>
              </div>

              <div class="lg:mb-2">
                <div class="mb-5 mr-20 flex items-center">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.AgruparEmailsAvisos"
                  />
                  <label for="switch-agrupar-emails-avisos" class="sr-only">
                    {{$t('configurations.mails_group_status')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('configurations.mails_group_status')}}
                  </label>
                  <el-switch 
                    id="switch-agrupar-emails-avisos"
                    :aria-label="$t('configurations.mails_group_status')"
                    class="switch-text break-normal" 
                    v-model="form.AgruparEmailsAvisos" 
                    :active-text="$t('configurations.mails_group_status')"></el-switch>
                  </div>
              </div>

              <div class="">
                <div class="mandatory flex items-center">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.EmailAvisoUltimaLlamada"
                  />
                  <div class="w-full">
                    <div class="flex items-center justify-between">
                      <div>
                        <label for="switch-email-aviso-ultima-llamada" v-if="form.AgruparEmailsAvisos" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                          {{$t('companies.mails_group_status_input')}}
                          <span class="sr-only">{{$t('app.options')}}: {{$t('configurations.add')}} / {{$t('configurations.sustitute')}}</span>
                        </label>
                        <label for="switch-email-aviso-ultima-llamada" v-else class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                          {{$t('companies.email_ultima_llamada')}}
                          <span class="sr-only">{{$t('app.options')}}: {{$t('configurations.add')}} / {{$t('configurations.sustitute')}}</span>
                        </label>
                      </div>
                      <el-switch 
                        v-if="!modeTemplate"
                        id="switch-email-aviso-ultima-llamada"
                        :aria-label="form.AgruparEmailsAvisos ? $t('companies.mails_group_status_input') : $t('companies.email_ultima_llamada')"
                        class="switch-text break-normal both-switch" 
                        v-model="valuesAdd.EmailAvisoUltimaLlamada" 
                        :inactive-text="$t('configurations.add')"
                        :active-text="$t('configurations.sustitute')" 
                        inactive-color="var(--primary-800)"
                        />
                    </div>
                    <el-form-item prop="EmailAvisoUltimaLlamada">
                      <el-input
                        clearable
                        v-model="form.EmailAvisoUltimaLlamada"
                        maxlength='500'
                      />
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="" v-if="form.AgruparEmailsAvisos === false">
                <div class="mandatory flex items-center">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.EmailAvisoTramitacionUrgente"
                  />
                  <div class="w-full">
                    <div class="flex items-center justify-between">
                      <label for="switch-email-aviso-tramitacion-urgente" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                        {{$t('companies.email_tramitacion_urgente')}}
                        <span class="sr-only">{{$t('app.options')}}: {{$t('configurations.add')}} / {{$t('configurations.sustitute')}}</span>
                      </label>
                      <el-switch 
                        v-if="!modeTemplate"
                        id="switch-email-aviso-tramitacion-urgente"
                        :aria-label="$t('companies.email_tramitacion_urgente')"
                        class="switch-text break-normal both-switch mt-2" 
                        v-model="valuesAdd.EmailAvisoTramitacionUrgente" 
                        :inactive-text="$t('configurations.add')"
                        :active-text="$t('configurations.sustitute')" 
                        inactive-color="var(--primary-800)"
                        />
                    </div>
                  <el-form-item prop="EmailAvisoTramitacionUrgente">
                    <el-input
                      clearable
                      v-model="form.EmailAvisoTramitacionUrgente"
                      maxlength='500'
                    />
                  </el-form-item>
                </div>
                </div>
              </div>
              <div class="" v-if="form.AgruparEmailsAvisos === false">
                <div class="mandatory flex items-center">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.EmailAvisoErrores"
                  />
                  <div class="w-full">
                    <div class="flex items-center justify-between">
                      <label for="switch-email-aviso-errores" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                        {{$t('companies.email_neos_error')}}
                        <span class="sr-only">{{$t('app.options')}}: {{$t('configurations.add')}} / {{$t('configurations.sustitute')}}</span>
                      </label>
                      <el-switch 
                        v-if="!modeTemplate"
                        id="switch-email-aviso-errores"
                        :aria-label="$t('companies.email_neos_error')"
                        class="switch-text break-normal both-switch mt-2" 
                        v-model="valuesAdd.EmailAvisoErrores" 
                        :inactive-text="$t('configurations.add')"
                        :active-text="$t('configurations.sustitute')" 
                        inactive-color="var(--primary-800)"
                        />
                    </div>
                  <el-form-item prop="EmailAvisoErrores">
                    <el-input
                      clearable
                      v-model="form.EmailAvisoErrores"
                      maxlength='500'
                    />
                  </el-form-item>
                  </div>
                </div>
              </div>

              <div class="">
                <div class="mandatory flex items-center">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.EmailAvisoVinculaciones"
                  />
                  <div class="w-full">
                    <div class="flex items-center justify-between">
                      <label for="switch-email-aviso-vinculaciones" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                        {{$t('companies.email_aviso_vincul')}}
                        <span class="sr-only">{{$t('app.options')}}: {{$t('configurations.add')}} / {{$t('configurations.sustitute')}}</span>
                      </label>
                      <el-switch 
                        v-if="!modeTemplate"
                        id="switch-email-aviso-vinculaciones"
                        :aria-label="$t('companies.email_aviso_vincul')"
                        class="switch-text break-normal both-switch mt-2" 
                        v-model="valuesAdd.EmailAvisoVinculaciones" 
                        :inactive-text="$t('configurations.add')"
                        :active-text="$t('configurations.sustitute')" 
                        inactive-color="var(--primary-800)"
                        />
                    </div>
                  <el-form-item prop="EmailAvisoVinculaciones">
                    <el-input
                      clearable
                      v-model="form.EmailAvisoVinculaciones"
                      maxlength='500'
                    />
                  </el-form-item>
                  </div>
                </div>
              </div>

              <div class="" v-if="hasModuleFlujoEstadosAvisos">
                <div class="mandatory flex items-center">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.EmailAvisoPrincipal"
                  />
                  <div class="w-full">
                    <div class="flex items-center justify-between">
                      <label for="switch-email-aviso-principal" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                        {{$t('companies.email_aviso_princ')}}
                        <span class="sr-only">{{$t('app.options')}}: {{$t('configurations.add')}} / {{$t('configurations.sustitute')}}</span>
                      </label>
                      <el-switch 
                        v-if="!modeTemplate"
                        id="switch-email-aviso-principal"
                        :aria-label="$t('companies.email_aviso_princ')"
                        class="switch-text break-normal both-switch mt-2" 
                        v-model="valuesAdd.EmailAvisoPrincipal" 
                        :inactive-text="$t('configurations.add')"
                        :active-text="$t('configurations.sustitute')" 
                        inactive-color="var(--primary-800)"
                        />
                    </div>
                  <el-form-item prop="EmailAvisoPrincipal">
                    <el-input
                      clearable
                      v-model="form.EmailAvisoPrincipal"
                      maxlength='500'
                    />
                  </el-form-item>
                  </div>
                </div>
              </div>

              <div class="" v-if="hasModuleFlujoEstadosAvisos">
                <div class="mandatory flex items-center">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.EmailAvisoSecundario"
                  />
                  <div class="w-full">
                    <div class="flex items-center justify-between">
                      <label for="switch-email-aviso-secundario" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                        {{$t('companies.email_aviso_sec')}}
                        <span class="sr-only">{{$t('app.options')}}: {{$t('configurations.add')}} / {{$t('configurations.sustitute')}}</span>
                      </label>
                      <el-switch 
                        v-if="!modeTemplate"
                        id="switch-email-aviso-secundario"
                        :aria-label="$t('companies.email_aviso_sec')"
                        class="switch-text break-normal both-switch mt-2" 
                        v-model="valuesAdd.EmailAvisoSecundario" 
                        :inactive-text="$t('configurations.add')"
                        :active-text="$t('configurations.sustitute')" 
                        inactive-color="var(--primary-800)"
                        />
                    </div>
                  <el-form-item prop="EmailAvisoSecundario">
                    <el-input
                      clearable
                      v-model="form.EmailAvisoSecundario"
                      maxlength='500'
                    />
                  </el-form-item>
                  </div>
                </div>
              </div>

            </template>
          </base-collapsible-form>
          
          </div>
        </el-form>
      </div>
      </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="isFromClient ? $t('app.cancel') : $t('app.back')" icon="cross" @click="goBack" :loading="isGeneralLoading"/>
          <base-button-responsive v-if="enableEditCampos" mode="primary" :forceIcon="true" :text="!modeTemplate ? $t('configurations.change_mode_template') : $t('configurations.change_mode_template_edit')" @click="toggleModeTemplate()"  icon="refresh" :loading="isGeneralLoading"/>
          <base-button-responsive v-if="modeTemplate" mode="primary" :text="$t('configurations.link_template_to_groups')" @click="toggleDialogLink"  icon="link" :loading="isGeneralLoading"/>
          <base-button-responsive 
            v-if="!modeTemplate" 
            mode="primary" 
            :text="$t('configurations.apply_to_groups')" 
            @click="toggleDialogLink"  
            icon="link" 
            :loading="isGeneralLoading"
            v-popover:popover
          />
          <base-button-responsive v-if="modeTemplate" mode="primary" :text="$t('app.save')" icon="save" @click="submitForm('ruleForm')" :loading="isGeneralLoading" :disabled="isGeneralLoading"/>
          <el-popover
            ref="popover"
            placement="top"
            width="250"
            v-model="showPopoverRedirection"
            popper-class="dark:bg-darkblue dark:border-darkblue-600 dark:text-darkblue-200"
            trigger="manual"
            >
            <p>Se han preseleccionado</p>
            <p>los grupos seleccionados. </p>
          </el-popover>
        </template>
      </base-footer>
      <link-groups-by-client-id-dialog
        ref="templatelinkgroupsdialog" 
        :title="titleLinkGroups" 
        :idCliente="this.id" 
        :modeTemplate="modeTemplate" 
        :dialogOpen="linkToGroupsDialog" 
        @toggleDialog="toggleDialogLink" 
        @applyDialog="applyLinkHandler" />
    </template>
  </detail-layout-full-width>
</template>

<script>
import { getClient } from '@/services/clients/getClient'
import { getGroupTemplate } from '@/services/configurations/groups/template/getGroupTemplate'
import { updateGroupTemplate } from '@/services/configurations/groups/template/updateGroupTemplate'
import { applyGroupTemplate } from '@/services/configurations/groups/template/applyGroupTemplate'
import { applyGroupKeys } from '@/services/configurations/groups/template/applyGroupKeys'

import { i18n } from '@/i18n'

import { email as emailRegex } from '@/utils/regex'
import DetailLayoutFullWidth from '../../components/layout/DetailLayoutFullWidth.vue'
import LinkGroupsByClientIdDialog from '@/components/LinkGroupsByClientIdDialog.vue'


function isValidEmail (value) {
  return value.split(';').every(item => emailRegex.test(item))
}
function isValidDay (value) {
  if (Number.isInteger(parseFloat(value))) {
    if (value >= 0 && value <= 8) {
      return true
    }
  }
  return false
}

function isValidDayEnd (value) {
  if (Number.isInteger(parseFloat(value))) {
    if (value >= 0 && value <= 30) {
      return true
    }
  }
  return false
}
export default {
  /* eslint-disable camelcase */
  name: 'template-detail',
  components: {
    DetailLayoutFullWidth,
    LinkGroupsByClientIdDialog,
  },
  data: function () {
    return {
      modeTemplate: true,
      showPopoverRedirection: false,
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      enableEditCampos: true,
      searchView: false,
      linkToGroupsDialog: false,
      activeName: 'es',
      header: {
        title: i18n.t('configurations.template_group_header_text'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: this.isFromClient ? 'configurations/clients/details' : 'configurations/groups'
      },
      tooltipverTodoGroups: this.$i18n.t('tooltip.groups.ver_todo_groups'),
      tooltipVerTodoStatuses: this.$i18n.t('tooltip.groups.ver_todo_statuses'),
      tooltipVerTodoCompanies: this.$i18n.t('tooltip.groups.ver_todo_companies'),
      checkall: false,
      valuesCheckbox: {
        verTodoGroups: false,
        verTodoStatuses: false,
        verTodoCompanies: false,

        EmailAvisoNueva: false,
        EmailAvisoDescargada: false,
        EmailAvisoTramitada: false,
        EmailAvisoVinculaciones: false,
        EmailAvisoPrincipal: false,
        EmailAvisoSecundario: false,
        AgruparEmailsAvisos: false,
        EmailAvisoUltimaLlamada: false,
        EmailAvisoTramitacionUrgente: false,
        EmailAvisoErrores: false,
        EnviarAvisos: false,
        EnviarAvisosUsuarios: false,
        DiasAviso: false,
        DiasFinTramite: false,
      },
      valuesAdd: {
        EmailAvisoNueva: true,
        EmailAvisoDescargada: true,
        EmailAvisoTramitada: true,
        EmailAvisoVinculaciones: true,
        EmailAvisoPrincipal: true,
        EmailAvisoSecundario: true,
        EmailAvisoUltimaLlamada: true,
        EmailAvisoTramitacionUrgente: true,
        EmailAvisoErrores: true,
      },
      form: {
        verTodoGroups: false,
        verTodoStatuses: false,
        verTodoCompanies: false,
        EmailAvisoNueva: null,
        EmailAvisoDescargada: null,
        EmailAvisoTramitada: null,
        EmailAvisoVinculaciones: null,
        EmailAvisoPrincipal: null,
        EmailAvisoSecundario: null,
        AgruparEmailsAvisos: false,
        EmailAvisoUltimaLlamada: '',
        EmailAvisoTramitacionUrgente: '',
        EmailAvisoErrores: '',
        EnviarAvisos: false,
        EnviarAvisosUsuarios: false,
        DiasAviso: null,
        DiasFinTramite: null,
        IdEmpresa: null,
        IdPlantilla: 0
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      rules: {
        EmailAvisoNueva: [
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoDescargada: [
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoTramitada: [
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoUltimaLlamada: [
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoTramitacionUrgente: [
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoErrores: [
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoVinculaciones: [
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoPrincipal: [
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoSecundario: [
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        DiasAviso: [
          { required: false, validator: this.isDayValid, trigger: 'blur' }
        ],
        DiasFinTramite: [
          { required: false, validator: this.isDayValidEnd, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    titleLinkGroups () {
      return this.modeTemplate ? 'Aplicar plantilla a grupos' : 'Aplicar campos seleccionados a grupos'
    },
    id () {
      return this.$route.params.id ? parseInt(this.$route.params.id) : -1
    },
    isFromClient () {
      return this.id !== -1
    },
    hasPermissionEditVisiblity () {
      return this.$store.getters['auth/hasPermissionEditVisiblity']
    },
    hasModuleFlujoEstadosAvisos () {
      return this.$store.getters['auth/hasModuleFlujoEstadosAvisos']
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    valuesCheckbox: {
      deep: true,
      immediate: true,
      handler: 'watchValuesCheckboxHandler'
    },
    'valuesCheckbox.EmailAvisoUltimaLlamada' (value, oldValue) {
      if (value) this.valuesCheckbox.AgruparEmailsAvisos = true
    },
    'valuesCheckbox.EmailAvisoTramitacionUrgente' (value, oldValue) {
      if (value) this.valuesCheckbox.AgruparEmailsAvisos = true
    },
    'valuesCheckbox.EmailAvisoErrores' (value, oldValue) {
      if (value) this.valuesCheckbox.AgruparEmailsAvisos = true
    },
    'valuesCheckbox.AgruparEmailsAvisos' (value, oldValue) {
      if (!value) {
        this.valuesCheckbox.EmailAvisoUltimaLlamada = false
        this.valuesCheckbox.EmailAvisoTramitacionUrgente = false
        this.valuesCheckbox.EmailAvisoErrores = false
      }
    },
    modeTemplate: function (value, oldValue) {
      if (!value) this.header.title = this.$i18n.t('configurations.template_group_header_text_mode')
      else this.header.title = this.$i18n.t('configurations.template_group_header_text')
    },
  },
  created: async function () {
    const breadcrumbs = []
    if (this.isFromClient) {
      breadcrumbs.push({
        path: this.role === 'SuperAdministrador' ? 'configurationssa' : 'configurations',
        name: this.$i18n.t('app.configurations')
      })
      breadcrumbs.push({
        path: 'configurations/clients',
        name: this.$i18n.t('app.clients')
      })
      if (this.$store.getters['app/fromRouteName'] !== null) {
        const breadcrumbHeader = this.$store.getters['app/headerBreadCrumb']
        breadcrumbs.push({ path: '', name: breadcrumbHeader })
      } else {
        const cliente = await this.downloadClientData(this.id)
        breadcrumbs.push({ path: '', name: cliente.empresa.Nombre })
        this.$store.commit('app/setheaderBreadCrumb', cliente.empresa.Nombre)
      }
    }
    this.header.breadcrumb = breadcrumbs
  },
  mounted: async function () {
    if (this.$route.params.data) {
      this.preSelectGroups()
    } else {
      const template = await this.downloadData(this.id)
      this.setTemplate(template.respuesta)
    }

    this.header.url = this.isFromClient ? 'configurations/clients/details' : 'configurations/groups'
    this.resetControlFormChanges()
  },
  methods: {
    preSelectGroups () {
      this.enableEditCampos = false
      this.modeTemplate = false
      const data = this.$route.params.data
      if (data && data.groups) {
        this.$refs.templatelinkgroupsdialog.changeSelectedGroups(data.groups)
      }
      this.togglePopoverRedirection()
    },
    togglePopoverRedirection: async function () {
      this.showPopoverRedirection = true
      setTimeout(() => {
        this.showPopoverRedirection = false
      }, 3000)
    },
    watchValuesCheckboxHandler: function () {
      const aux = this.valuesCheckbox
      const checkboxKeys = Object.keys(aux)
      this.checkall = true
      checkboxKeys.forEach(key => {
        if (!aux[key]) {
          this.checkall = false
          return false
        }
      })
    },
    toggleModeTemplate: function () {
      this.modeTemplate = !this.modeTemplate
    },
    changeAllCheckbox (value) {
      this.valuesCheckbox.verTodoGroups = value
      this.valuesCheckbox.verTodoStatuses = value
      this.valuesCheckbox.verTodoCompanies = value
      this.valuesCheckbox.EmailAvisoNueva = value
      this.valuesCheckbox.EmailAvisoDescargada = value
      this.valuesCheckbox.EmailAvisoTramitada = value
      this.valuesCheckbox.EmailAvisoVinculaciones = value
      this.valuesCheckbox.EmailAvisoPrincipal = value
      this.valuesCheckbox.EmailAvisoSecundario = value
      this.valuesCheckbox.AgruparEmailsAvisos= value
      this.valuesCheckbox.EmailAvisoUltimaLlamada = value
      this.valuesCheckbox.EmailAvisoTramitacionUrgente = value
      this.valuesCheckbox.EmailAvisoErrores = value
      this.valuesCheckbox.EnviarAvisos = value
      this.valuesCheckbox.EnviarAvisosUsuarios = value
      this.valuesCheckbox.DiasAviso = value
      this.valuesCheckbox.DiasFinTramite = value
    },
    toggleDialogLink: function () {
      this.linkToGroupsDialog = !this.linkToGroupsDialog
    },
    applyLinkHandler: async function (groups) {
      if (this.modeTemplate) {
        this.submitFormAndUpdateGroups('ruleForm', groups)
      } else {
        this.UpdateGroupsWithSelected('ruleForm', groups)
      }
    },
    downloadClientData: async function (id) {
      let client = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idEmpresa: id
        }
        client = await getClient(params)
        if (client.blnError === true) {
          this.doFeedback(client.msgError + ' [Código de error: ' + client.codError + ']')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return client
    },
    watchFormHandler: function ({ send_alerts, AgruparEmailsAvisos }) {
      if (send_alerts !== undefined) {
        this.form.send_alerts = !!send_alerts
      }
      // Control para ocultar las no visibles
      if (AgruparEmailsAvisos !== undefined && AgruparEmailsAvisos === true) {
        this.valuesCheckbox.EmailAvisoErrores = false
        this.valuesCheckbox.EmailAvisoTramitacionUrgente = false
      }
      this.$store.commit('app/setFormChanges', true)
    },
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        callback() // queremos que la validación sea opcional en este caso.
      } else if (!isValidEmail(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.email_multiple'), callback)
      } else {
        callback()
      }
    },
    isDayValid: function (rule, value, callback) {
      if (!value) {
        callback() // queremos que la validación sea opcional en este caso.
      } else if (!isValidDay(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.template.aviso'), callback)
      } else {
        callback()
      }
    },
    isDayValidEnd: function (rule, value, callback) {
      if (!value) {
        callback() // queremos que la validación sea opcional en este caso.
      } else if (!isValidDayEnd(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.template.aviso_fin_tramite'), callback)
      } else {
        callback()
      }
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    submitForm: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const params = {
            VerTodoGrupos: this.form.verTodoGroups,
            VerTodoEmpresas: this.form.verTodoCompanies,
            VerTodoEstados: this.form.verTodoStatuses,
            EmailAvisoNueva: this.form.EmailAvisoNueva,
            EmailAvisoDescargada: this.form.EmailAvisoDescargada,
            EmailAvisoTramitada: this.form.EmailAvisoTramitada,
            EmailAvisoVinculaciones: this.form.EmailAvisoVinculaciones,
            EmailAvisoPrincipal: this.form.EmailAvisoPrincipal,
            EmailAvisoSecundario: this.form.EmailAvisoSecundario,
            EmailDiasAviso: this.form.EmailAvisoUltimaLlamada,
            EmailAvisoTramitacionUrgente: this.form.EmailAvisoTramitacionUrgente,
            EmailAvisoErrores: this.form.EmailAvisoErrores,
            AgruparEmailsAvisos: this.form.AgruparEmailsAvisos,
            EnviarAvisos: this.form.EnviarAvisos,
            EnviarAvisosUsuarios: this.form.EnviarAvisosUsuarios,
            DiasAviso: this.form.DiasAviso,
            DiasFinTramite: this.form.DiasFinTramite,
            IdEmpresa: this.form.IdEmpresa,
            IdPlantilla: this.form.IdPlantilla,
          }
          const response = await updateGroupTemplate({ idEmpresa: this.id }, params)
          if (response.blnError === true) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.doFeedback('Plantilla guardada correctamente', 'success')
            this.resetControlFormChanges()
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    submitFormAndUpdateGroups: function (formName, groups) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const params = {
            VerTodoGrupos: this.form.verTodoGroups,
            VerTodoEmpresas: this.form.verTodoCompanies,
            VerTodoEstados: this.form.verTodoStatuses,
            EmailAvisoNueva: this.form.EmailAvisoNueva,
            EmailAvisoDescargada: this.form.EmailAvisoDescargada,
            EmailAvisoTramitada: this.form.EmailAvisoTramitada,
            EmailAvisoVinculaciones: this.form.EmailAvisoVinculaciones,
            EmailAvisoPrincipal: this.form.EmailAvisoPrincipal,
            EmailAvisoSecundario: this.form.EmailAvisoSecundario,
            EmailDiasAviso: this.form.EmailAvisoUltimaLlamada,
            EmailAvisoTramitacionUrgente: this.form.EmailAvisoTramitacionUrgente,
            EmailAvisoErrores: this.form.EmailAvisoErrores,
            AgruparEmailsAvisos: this.form.AgruparEmailsAvisos,
            EnviarAvisos: this.form.EnviarAvisos,
            EnviarAvisosUsuarios: this.form.EnviarAvisosUsuarios,
            DiasAviso: this.form.DiasAviso,
            DiasFinTramite: this.form.DiasFinTramite,
            IdEmpresa: this.form.IdEmpresa,
            IdPlantilla: this.form.IdPlantilla,
          }
          this.toggleDialogLink()
          const response = await updateGroupTemplate({ idEmpresa: this.id }, params)
          if (response.blnError === true) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.doFeedback('Plantilla guardada correctamente', 'success')
            this.resetControlFormChanges()
            const response = await applyGroupTemplate({ idEmpresa: this.id }, groups)
            if (response.blnError === true) {
              this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
            } else {
              this.doFeedback('Grupos actualizados correctamente', 'success')
            }
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    UpdateGroupsWithSelected: function (formName, groups) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const params = {
            idGrupos: groups,

            checkVerTodoGrupos: this.valuesCheckbox.verTodoGroups,
            checkVerTodoEmpresas: this.valuesCheckbox.verTodoCompanies,
            checkVerTodoEstados: this.valuesCheckbox.verTodoStatuses,
            checkEmailAvisoNueva: this.valuesCheckbox.EmailAvisoNueva,
            checkEmailAvisoDescargada: this.valuesCheckbox.EmailAvisoDescargada,
            checkEmailAvisoTramitada: this.valuesCheckbox.EmailAvisoTramitada,
            checkEmailAvisoVinculaciones: this.valuesCheckbox.EmailAvisoVinculaciones,
            checkEmailAvisoPrincipal: this.valuesCheckbox.EmailAvisoPrincipal,
            checkEmailAvisoSecundario: this.valuesCheckbox.EmailAvisoSecundario,
            checkEmailDiasAviso: this.valuesCheckbox.EmailAvisoUltimaLlamada,
            checkEmailAvisoTramitacionUrgente: this.valuesCheckbox.EmailAvisoTramitacionUrgente,
            checkEmailAvisoErrores: this.valuesCheckbox.EmailAvisoErrores,
            checkAgruparEmailsAvisos: this.valuesCheckbox.AgruparEmailsAvisos,
            checkEnviarAvisos: this.valuesCheckbox.EnviarAvisos,
            checkEnviarAvisosUsuarios: this.valuesCheckbox.EnviarAvisosUsuarios,
            checkDiasAviso: this.valuesCheckbox.DiasAviso,
            checkDiasFinTramite: this.valuesCheckbox.DiasFinTramite,

            addEmailAvisoNueva: !this.valuesAdd.EmailAvisoNueva,
            addEmailAvisoDescargada: !this.valuesAdd.EmailAvisoDescargada,
            addEmailAvisoTramitada: !this.valuesAdd.EmailAvisoTramitada,
            addEmailAvisoVinculaciones: !this.valuesAdd.EmailAvisoVinculaciones,
            addEmailAvisoPrincipal: !this.valuesAdd.EmailAvisoPrincipal,
            addEmailAvisoSecundario: !this.valuesAdd.EmailAvisoSecundario,
            addEmailDiasAviso: !this.valuesAdd.EmailAvisoUltimaLlamada,
            addEmailAvisoTramitacionUrgente: !this.valuesAdd.EmailAvisoTramitacionUrgente,
            addEmailAvisoErrores: !this.valuesAdd.EmailAvisoErrores,
            
            VerTodoGrupos: this.form.verTodoGroups,
            VerTodoEmpresas: this.form.verTodoCompanies,
            VerTodoEstados: this.form.verTodoStatuses,
            EmailAvisoNueva: this.form.EmailAvisoNueva,
            EmailAvisoDescargada: this.form.EmailAvisoDescargada,
            EmailAvisoTramitada: this.form.EmailAvisoTramitada,
            EmailAvisoVinculaciones: this.form.EmailAvisoVinculaciones,
            EmailAvisoPrincipal: this.form.EmailAvisoPrincipal,
            EmailAvisoSecundario: this.form.EmailAvisoSecundario,
            EmailDiasAviso: this.form.EmailAvisoUltimaLlamada,
            EmailAvisoTramitacionUrgente: this.form.EmailAvisoTramitacionUrgente,
            EmailAvisoErrores: this.form.EmailAvisoErrores,
            AgruparEmailsAvisos: this.form.AgruparEmailsAvisos,
            EnviarAvisos: this.form.EnviarAvisos,
            EnviarAvisosUsuarios: this.form.EnviarAvisosUsuarios,
            DiasAviso: this.form.DiasAviso,
            DiasFinTramite: this.form.DiasFinTramite,
            IdEmpresa: this.form.IdEmpresa,
            IdPlantilla: this.form.IdPlantilla,
          }
          this.toggleDialogLink()
          const response = await applyGroupKeys({ idEmpresa: this.id }, params)
          if (response.blnError === true) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.doFeedback('Grupos actualizados correctamente', 'success')
            this.resetControlFormChanges()
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    goBack: function () {
      if (this.isFromClient) this.$router.push({ name: 'configurations/clients/details', params: this.id })
      else this.$router.push({ name: 'configurations/groups' })
    },
    downloadData: async function (id) {
      try {
        this.$store.commit('setIsLoading', true)
        const template = await getGroupTemplate({ idEmpresa: this.id })
        if (template.blnError === true) {
          this.doFeedback(template.msgError + ' [Código de error: ' + template.codError + ']')
        } else {
          return template
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
    setTemplate: function (template) {
      if (template) {
        this.form.verTodoGroups = template.VerTodoGrupos ? template.VerTodoGrupos : false
        this.form.verTodoCompanies = template.VerTodoEmpresas ? template.VerTodoEmpresas : false
        this.form.verTodoStatuses = template.VerTodoEstados ? template.VerTodoEstados : false

        this.form.EmailAvisoNueva = template.EmailAvisoNueva ? template.EmailAvisoNueva : null
        this.form.EmailAvisoDescargada = template.EmailAvisoDescargada ? template.EmailAvisoDescargada : null
        this.form.EmailAvisoTramitada = template.EmailAvisoTramitada ? template.EmailAvisoTramitada : null
        this.form.EmailAvisoVinculaciones = template.EmailAvisoVinculaciones ? template.EmailAvisoVinculaciones : null
        this.form.EmailAvisoPrincipal = template.EmailAvisoPrincipal ? template.EmailAvisoPrincipal : null
        this.form.EmailAvisoSecundario = template.EmailAvisoSecundario ? template.EmailAvisoSecundario : null
        this.form.EmailAvisoUltimaLlamada = template.EmailDiasAviso ? template.EmailDiasAviso : null
        this.form.EmailAvisoTramitacionUrgente = template.EmailAvisoTramitacionUrgente ? template.EmailAvisoTramitacionUrgente : null
        this.form.EmailAvisoErrores = template.EmailAvisoErrores ? template.EmailAvisoErrores : null
        this.form.AgruparEmailsAvisos = template.AgruparEmailsAvisos ? template.AgruparEmailsAvisos : false
        this.form.EmailTecnico = template.EmailTecnico ? template.EmailTecnico : null
        this.form.EnviarAvisos = template.EnviarAvisos ? template.EnviarAvisos : null
        this.form.EnviarAvisosUsuarios = template.EnviarAvisosUsuarios ? template.EnviarAvisosUsuarios : null
        this.form.DiasAviso = template.DiasAviso !== null || template.DiasAviso !== undefined ? template.DiasAviso : null
        this.form.DiasFinTramite = template.DiasFinTramite !== null || template.DiasFinTramite !== undefined ? template.DiasFinTramite : null
        this.form.IdEmpresa = template.IdEmpresa ? template.IdEmpresa : null
        this.form.IdPlantilla = template.IdPlantilla ? template.IdPlantilla : null
      }
      this.resetControlFormChanges()
    }
  }

}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr ;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic>img {
  max-width: 100%;
}

</style>

<style lang="sass" scoped>
</style>
